<template>
  <b-row>
    <b-col
      cols="6"
    >
      <Select2
        label="Empleado: "
        :options="employeesOp"
        reduce
        v-model="filters.employee"
      />
    </b-col>
    <b-col
      cols="6"
    >
      <Select2
        label="Motivo: "
        reduce
        :options="reasonForPermissionOp"
        v-model="filters.reason"
      />
    </b-col>
    <b-col cols="6">
      <DatePicker
        label="Fecha Inicial: "
        v-model="filters.dateStart"
      />
    </b-col>
    <b-col cols="6">
      <DatePicker
        label="Fecha Final: "
        :min="filters.dateStart"
        :disabled="!filters.dateStart"
        v-model="filters.dateEnd"
      />
    </b-col>
    <b-col class="text-right">
      <b-button
        size="sm"
        variant="info"
        class="mt-4 mr-1"
        @click="$emit('search')"
      >
        <i class="fas fa-search mr-1 "/> Filtrar
      </b-button>
      <b-button
        size="sm"
        variant="dark"
        class="mt-4 ml-1"
        @click="$emit('clear')"
      >
        <i class="fas fa-ban mr-1" /> Limpiar
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import { defineComponent } from '@vue/composition-api'

// components
import { DatePicker, Select2 } from '@/components/general'

// hooks
import { useEmployeesOp, useReasonForPermission } from '@/hooks'

export default defineComponent({
  name: 'FiltersPermissionControl',
  components: {
    DatePicker,
    Select2
  },
  props: {
    filters: {
      required: true,
      type: Object
    }
  },
  setup () {
    const { employeesOp } = useEmployeesOp()
    const { reasonForPermissionOp } = useReasonForPermission()

    return {
      employeesOp,
      reasonForPermissionOp
    }
  }
})
</script>
